const allowedCodes = new Set([
  ...new Array(100).fill('').map((_, i) => `AM${i + 1}`),
  ...new Array(100).fill('').map((_, i) => `NM${i + 1}`),
  ...new Array(300).fill('').map((_, i) => `ERR${i + 1}`),

  '10500', '11002', '11004', '11009', '11015', '11016', '11017', '11018', '11020',
  '11021', '11022', '11023', '11024', '11025', '11026',
  '11406', '11500', '20003', '20004', '20005', '20006',

  'PS1', 'PS2', 'PS3', 'PS4', 'PS5', 'PS6', 'PS7', 'PS8', 'PS9', 'PS10',

  'AC1', 'AC2', 'AC3', 'AC4', 'AC5', 'AC6', 'AC7', 'AC8',
  'VC1', 'VC2', 'VC3', 'VC4', 'VC5', 'VC6', 'VC7',

  'reached-users-limit',
  'reached-transcription-limit',
  'reached-storage-limit',
  'reached-translation-limit',
  'reached-bandwidth-limit',
  'reached-rekognition-limit',
  'reached-clientuser-limit',
  'reached-credits-limit',
  'reached-resource-limit',
  'system-error',
  'fileConversionComplete',

  // These are not in use, but we have to keep them for compatibility with the DB records
  'upcoming-users-limit',
  'upcoming-transcription-limit',
  'upcoming-storage-limit',
  'upcoming-translation-limit',
  'upcoming-bandwidth-limit',
  'upcoming-rekognition-limit',
  'upcoming-clientuser-limit',
  'upcoming-credits-limit',
]);

export const createReplaceT = () => ({
  install(app) {
    app.config.globalProperties.$replaceT = function (code, params, fallback) {
      let paramsObject = {};

      if (!code) {
        return fallback;
      }

      if (typeof code !== 'string') {
        code = code.toString();
      }

      try {
        if (typeof params === 'string') {
          paramsObject = JSON.parse(params);
        } else if (typeof params === 'object' && params !== null) {
          paramsObject = params;
        }
        // eslint-disable-next-line no-unused-vars
      } catch (_) {
        return fallback;
      }

      if (allowedCodes.has(code)) {
        return this.$t('backend.' + code, paramsObject);
      } else {
        return 'Unsupported code: ' + code;
      }
    };
  },
});
